const UserActivate = () => {

    return(
        <div style={{width:'100vw',background:'#242424',minHeight:'100vh'}}>
            <h1 style={{color:'white', padding:'50px'}}>미구현</h1>
        </div>
    )
}

export default UserActivate;